<mat-dialog-content>
    <div class="error-modal" *ngIf="passwordError">
        <button type="button" #closebutton class="close btn-close"
        [mat-dialog-close]="false" data-dismiss="modal"> <i
          class="fa-solid fa-xmark"></i></button> 
       <div class="d-flex align-items-center gap-3 w-100">
        <span class="material-icons verified-icon  text-danger">
            info
            </span>
         
       
        <h6 class="m-0 text-black error-text">{{title | translate}}</h6>
       </div>
     
        <h6 class="text-center text-black mt-4">{{message | translate}}</h6>
       
    </div>

        <div class="verification-modal" *ngIf="!passwordError">
        <mat-icon class="verified-icon text-success"aria-hidden="false" aria-label="Example home icon" fontIcon="check_circle_outline"></mat-icon>
       <!-- <mat-icon class="verified-icon text-danger"aria-hidden="false" aria-label="Example home icon" fontIcon="info_outline"></mat-icon>  -->
       <h6 class="m-0 text-black error-text" *ngIf="title!=''">{{title  | translate }}</h6>
        <h4 style="white-space: pre-line;">{{ message | translate}}</h4>
        <button mat-flat-button color="primary" class="my-3 px-5" (click)="closeDialog()">{{'LOGIN' | translate}}</button>
    </div>

  
  </mat-dialog-content>
  


  